export default __webpack_public_path__ + "static/media/back.91d3585e.png";